// Show a category on the website only if it has deals.
// dealCount comes from the backend. If it's missing (older backend), show the category anyway.
// Admin pages (Add Deals, Add Category) don't use this, so they still list every category.
export const hasDeals = (category) =>
  category.dealCount === undefined || category.dealCount > 0;
